<button 
    class="btn btn-secondary"
    [disabled]="isDisabled"
    (click)="exportAll()"
    [ngbTooltip]="'Export all customer domains to JSON file' | translate"
    [attr.aria-label]="'Export all domains' | translate"
    data-test="export-all-domains">
    <i class="fas fa-download" *ngIf="!isExporting"></i>
    <i class="fas fa-spinner fa-spin" *ngIf="isExporting"></i>
    <span class="ml-1" translate>Export All</span>
    <span class="ml-1" *ngIf="isExporting && progress.total > 0">({{ progress.current }}/{{ progress.total }})</span>
</button>